import React, { createContext, useContext, ReactNode } from 'react';
import { PublicClientApplication, IPublicClientApplication } from '@azure/msal-browser';
import { MsalProvider, useMsal } from '@azure/msal-react';

interface AuthProviderProps {
    children: ReactNode;
}

const msalConfig = {
    auth: {
        clientId: "a217ed32-d9bc-4b75-9012-272659a1091f",
        authority: "https://login.microsoftonline.com/85cbec59-2bd3-4a20-9b1c-e150eab0fca5",
        redirectUri: "https://wideroe.crud.no/",
    },
    cache: {
        cacheLocation: "sessionStorage", // This ensures tokens are stored securely for SPAs
        storeAuthStateInCookie: false, // Set to true if experiencing issues on IE11/Edge
    }
};

const pca: IPublicClientApplication = new PublicClientApplication(msalConfig);

const AuthContext = createContext<IPublicClientApplication>(pca);

export const useAuth = () => useContext(AuthContext);


export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    return (
        <MsalProvider instance={pca}>
            <AuthContext.Provider value={pca}>
                {children}
            </AuthContext.Provider>
        </MsalProvider>
    );
};